import React, { FC, memo } from 'react';
import styles from './back-button.module.css';
import clsx from 'clsx';
import LeftArrow from '$icons/arrow-left.svg';

type Props = {
    onClick?: () => void;
    selectedSubMenu?: boolean;
    text?: string;
    isSearchPage?: boolean;
};

const BackButton: FC<Props> = memo(({ onClick, selectedSubMenu, text, isSearchPage }) => (
    <button
        className={clsx('cleanButton', styles.root, {
            [styles.selectedSubMenu]: selectedSubMenu,
            [styles.searchPage]: isSearchPage,
        })}
        onClick={() => onClick?.()}
    >
        <LeftArrow />
        {text}
    </button>
));

BackButton.displayName = 'BackButton';
export default BackButton;
